import {
	Box,
	Container,
	Divider,
	makeStyles,
	Typography,
	LinearProgress
} from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import { useActions, useValues } from 'kea';
import Fuse from 'fuse.js';

import assetlogic from 'src/store/asset';
import profilelogic from 'src/store/profile';

import Page from 'src/components/Page';
import checkRole from '../../utils/checkRole';
import Result from './Results';
import Toolbar from './Toolbar';

//TODO clean styles
const useStyles = makeStyles((theme) => ({
	root: {
		backgroundColor: theme.palette.background.dark,
		minHeight: '100%',
		paddingBottom: theme.spacing(3),
		paddingTop: theme.spacing(3)
	},
	card: {

	}
}));


let columns = [
	{
		field: 'image',
		headerName: 'Icon',
		align: 'left',
		width: 50,
	},
	{
		field: 'type',
		headerName: 'Type',
		align: 'left',
		width: 200,
	},
	{
		field: 'name',
		headerName: 'Name',
		align: 'left',
		width: 200,
	},
	{
		field: 'info',
		headerName: 'Information',
		align: 'left',
		width: 250,
	},
	{
		field: 'groups',
		headerName: 'Groups',
		align: 'left',
		width: 70,
	},
	{
		field: 'actions',
		align: 'left',
		headerName: 'Actions',
		width: 150,
	},
];




const MobileAssetsViewFunc = () => {

	const classes = useStyles();

	const { profile } = useValues(profilelogic);

	const { assets } = useValues(assetlogic);
	const { fetchAll: assetFetchAll } = useActions(assetlogic);

	const [filtered, setFiltered] = useState(assets);

	const [search, setSearch] = useState('');

	useEffect(() => {
		assets ?? assetFetchAll();
	}, []) // eslint-disable-line

	useEffect(() => {
		if (search === '') {
			setFiltered(assets);
		} else {
			let found = fuse.search(search);
			found = found.map(item => {
				item.item.refIndex = item.refIndex;
				return item.item;
			});
			setFiltered(found);
		}
	}, [assets, search])// eslint-disable-line


	if (!checkRole(profile, ['AssetEdit'])) {
		columns = columns.filter((item) => {
			return item.field !== 'actions';
		});
	}

	if (assets === null) {
		return <LinearProgress />
	}

	const fuse = new Fuse(assets, {
		keys: ['tags', 'type', 'name', 'odometer', 'registration_number', 'registration_state', 'company', 'model', 'year', 'color']
	});

	const handle_search = (e) => setSearch(e.target.value);



	return (
		<Page
			className={classes.root}
			title="Assets"
		>
			<Container maxWidth={false}>
				<Box mt={3} >
					<Typography variant="h3" gutterBottom>
						Assets
					</Typography>
					<Divider />
				</Box>
				<Toolbar on_search={handle_search} />
				<Box mt={3}>
					<Result rows={filtered} columns={columns} />
				</Box>
			</Container>
		</Page>
	);
};

export default MobileAssetsViewFunc;
